import React, { useEffect, useState } from "react";
import { Modal, Box, TextField, Button, Typography } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { styleModalDocs } from "../../estilo/modal";
import axiosInstancePromise from "../../general/axiosConfig";

const excluir_col = ['id'];

const ModalAgregar = ({ open, handleClose, fetchData, tabla }) => {
  const [campos, setCampos] = useState([]);
  const [ tablaActual, setTablaActual ] = useState('');
  const { control, handleSubmit } = useForm();
  const multilineFields = ['mensaje', 'descripcion', 'descripcion_codigo_esp'];
  const labelMap = {
    nombre_cliente: 'Nombre del cliente',
    nit: 'NIT',
    correo: 'Correo',
    asunto: 'Asunto',
    mensaje: 'Mensaje',
    descripcion: 'Descripción',
    descripcion_codigo_esp: 'Descripción',
    cod_gen: 'Código general',
    codigo_esp: 'Código específico',
    cod_esp: 'Código específico',
  };

  const tlabelMap = {
    DiccionarioClientes: 'Diccionario de clientes',
    DiccionarioCodigoGen: 'Diccionario de códigos generales',
    DiccionarioCodigoEsp : 'Diccionario de códigos específicos'
  };

  useEffect(() => {
    if (open) {
      const view = localStorage.getItem('view');
      if (view) {
        setTablaActual(view);
      }
    }
  }, [open]);
  
  useEffect(() => {
    const fetchCampos = async () => {
      if (tablaActual) {
        try {
          const axiosInstance = await axiosInstancePromise;
          const response = await axiosInstance.get(`/campos-tabla/${tablaActual}`);
          const allRows = response.data.rows || [];
          const filtrarCols = allRows.filter(row => !excluir_col.includes(row.COLUMN_NAME));
          setCampos(filtrarCols);
        } catch (error) {
          console.error("Error al cargar los campos de la tabla:", error);
        }
      }
    };

    fetchCampos();
  }, [tablaActual]);

  const onSubmit = async (data) => {
    try {
      const axiosInstance = await axiosInstancePromise;
      const response = await axiosInstance.post(`/agregar-registro/${tablaActual}`,{data});
      handleClose();
      fetchData(); 
    } catch (error) {
      console.error("Error al enviar los datos:", error);
    }
  };
  
  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="modal-title" aria-describedby="modal-description" >
      <Box sx={styleModalDocs}>
        <Box mt={2} display="flex" justifyContent="center">
          <Typography id="modal-title" variant="h5" component="h2" align="center">
          Agregar registro en el {tlabelMap[tablaActual]}
          </Typography>
        </Box>
        <form onSubmit={handleSubmit(onSubmit)}>
          {campos.length > 0 ? (
            campos.map((rows, index) => (
              <Box key={index} display="flex" alignItems="center" mt={2}>
                {
                  rows.COLUMN_NAME === 'id'? '': 
                  <Controller
                  name={rows.COLUMN_NAME}
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      {...field}
                      margin="normal"
                      required
                      fullWidth
                      multiline={multilineFields.includes(rows.COLUMN_NAME)}
                      type={rows.DATA_TYPE === 'int'? "number" : 'text'}
                      label={labelMap[rows.COLUMN_NAME] || rows.COLUMN_NAME}
                      rows={multilineFields.includes(rows.COLUMN_NAME) ? 7 : 1}
                      sx={multilineFields.includes(rows.COLUMN_NAME) ? { mt: 2, mb: 2, fontSize: '1.1rem' } : {}}
                    />
                  )}
                /> }
              </Box>
            ))
          ) : (
            <Typography variant="body1" mt={2}>
              Cargando campos...
            </Typography>
          )}
          <Box mt={2} display="flex" justifyContent="center">
            <Button type="submit" variant="contained" sx={{ background: "black" }}>
              Guardar
            </Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
};

export default ModalAgregar;
